import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura Martínez',
    company: 'Cafetería Aroma',
    text: 'Gracias a Sinapsis Digital, nuestra presencia en redes sociales creció exponencialmente. Las ventas en línea aumentaron un 45% en solo tres meses.',
    stars: 5
  }, {
    name: 'Carlos Rodríguez',
    company: 'Muebles Contemporáneos',
    text: 'El rediseño de nuestra tienda online superó todas nuestras expectativas. El proceso fue profesional de principio a fin y los resultados hablan por sí mismos.',
    stars: 5
  }, {
    name: 'María González',
    company: 'Academia de Idiomas GlobalTalk',
    text: 'Las campañas publicitarias diseñadas por Sinapsis Digital nos ayudaron a captar nuevos alumnos y expandir nuestro negocio a otras provincias.',
    stars: 5
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-145">
      <div className="container mx-auto px-4" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-148">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-149">
            Historias de éxito que reflejan nuestro compromiso con los
            resultados.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-151">
              <div className="flex mb-4" data-id="element-152">
                {[...Array(testimonial.stars)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-500 fill-current" data-id="element-153" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-154">"{testimonial.text}"</p>
              <div data-id="element-155">
                <p className="font-semibold text-gray-900" data-id="element-156">
                  {testimonial.name}
                </p>
                <p className="text-gray-600 text-sm" data-id="element-157">{testimonial.company}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}